// src/utils/eventBus.js
// Basit EventTarget tabanlı event bus
const eventBus = new EventTarget();

export default eventBus;